import { TextInput } from '@app/components';
import React from 'react';
import { StyledForms } from '@app/components/styled/form/Form';

export const KitchenAreaForm = () => {
  return (
    <StyledForms.Form>

      <TextInput
        name="name"
        label="Nom"
        autoCapitalize="none" />

    </StyledForms.Form>
  );
};
